import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import vvisualized from "../assets/web/vvisualized.png";
import legaldhanda from "../assets/web/legaldhanda.png";
import khanbrothers from "../assets/web/khanbrothers.png";
import athenaeum from "../assets/web/athenaeum.png";
import HireUsModal from "../components/HireUsModal";
function SiteListComponent() {
  const [sites] = useState([
    {
      image: vvisualized,
      companyName: "Virtully Visualized",
      techStack: "Vanila Javascript",
      type: "Company Portfolio",
      url: "https://www.vvisualized.com/",
    },
    {
      image: legaldhanda,
      companyName: "Legal Dhanda",
      techStack: "React JS",
      type: "PWA",
      url: "https://legaldhanda.netlify.app/",
    },
    {
      image: athenaeum,
      companyName: "The Athenaeum Greens",
      techStack: "React JS",
      type: "Business Website",
      url: "https://athenaeumgreen.netlify.app/",
    },
    {
      image: khanbrothers,
      companyName: "Khan Brothers",
      techStack: "Wordpress",
      type: "E-commerce",
      url: "",
    },
  ]);
  return (
    <div className="site-list">
      <Container>
        {sites.map((data) => (
          <Row className="site" key={data.image}>
            <Col xs={12} md={6}>
              <img
                src={data.image}
                alt="..."
                className="img-fluid site-img shadow-sm"
              />
            </Col>
            <Col xs={12} md={6} className="site-details-container">
              <div className="site-details shadow">
                <h3>{data.companyName}</h3>
                <div>
                  <p>
                    Building website is easy. But building website with good
                    performance is tricky. Here, we've some example to showcase.
                  </p>
                  <p>Framework / Language : {data.techStack}</p>
                  <p>Website Type : {data.type}</p>
                </div>
                <div>
                  <button className="btn btn-custom">
                    <a target="_blank" href={data.url}>
                      View Demo
                    </a>
                  </button>
                  <HireUsModal outlined={true} />
                </div>
              </div>
            </Col>
          </Row>
        ))}
      </Container>
    </div>
  );
}

export default SiteListComponent;
